"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useControllableState = exports.useControllableProp = void 0;
const React = __importStar(require("react"));
const utils_1 = require("@icr-ui/utils");
const use_callback_ref_1 = require("./use-callback-ref");
function useControllableProp(prop, state) {
    const isControlled = prop !== undefined;
    const value = isControlled && typeof prop !== 'undefined' ? prop : state;
    return [isControlled, value];
}
exports.useControllableProp = useControllableProp;
/**
 * React hook for using controlling component state.
 * @param props
 */
function useControllableState(props) {
    const { value: valueProp, defaultValue, onChange, shouldUpdate = (prev, next) => prev !== next, } = props;
    const onChangeProp = (0, use_callback_ref_1.useCallbackRef)(onChange);
    const shouldUpdateProp = (0, use_callback_ref_1.useCallbackRef)(shouldUpdate);
    const [valueState, setValue] = React.useState(defaultValue);
    const isControlled = valueProp !== undefined;
    const value = isControlled ? valueProp : valueState;
    const updateValue = React.useCallback((next) => {
        const nextValue = (0, utils_1.runIfFn)(next, value);
        if (!shouldUpdateProp(value, nextValue)) {
            return;
        }
        if (!isControlled) {
            setValue(nextValue);
        }
        onChangeProp(nextValue);
    }, [isControlled, onChangeProp, value, shouldUpdateProp]);
    return [value, updateValue];
}
exports.useControllableState = useControllableState;
//# sourceMappingURL=use-controllable.js.map